export default [
  {
    path: '/admin',
    name: 'home',
    component: () => import('@/pages/Home'),
    meta: {
      title: "數據儀表",
      requireAuth: true,
      isSupportMobile: true
    }
  },
  {
    path: '/admin/contest',
    name: 'contest-management',
    component: () => import('@/pages/Contest'),
    meta: {
      title: "量測管理",
      requireAuth: true,
      isSupportMobile: true
    }
  },
  {
    path: '/admin/appointment',
    name: 'appointment',
    component: () => import('@/pages/Appointment'),
    meta: {
      title: "預約管理",
      requireAuth: true,
      isSupportMobile: true
    }
  },
]
